"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var CardOptionValue = /*#__PURE__*/function () {
  function CardOptionValue(opt) {
    _classCallCheck(this, CardOptionValue);

    this.section = null;
    this.value = null;
    this.count = 0;
    this.optionsId = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(CardOptionValue, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.section = opt.section;
      this.value = opt.value;
      this.count = opt.count || 0;
      this.optionsId = opt.optionsId ? new ObjectId(opt.optionsId) : null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, CardOptionValue.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'card-option-value.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          section: {
            type: ['string', 'null']
          },
          value: {
            type: 'string'
          },
          count: {
            type: 'number'
          },
          optionsId: {
            type: ['object', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return CardOptionValue;
}();

module.exports = CardOptionValue;